import {
  FaRobot,
  FaTimes,
  FaCircle,
} from "react-icons/fa";

export default function ChatHeader({
  onClose,
}) {
  return (
    <div className="chatbot-header">

      <div className="chatbot-title">

        <FaRobot className="chatbot-logo" aria-hidden="true" />

        <div>

          <h3>Techizen AI</h3>

          <span className="chatbot-status">

            <FaCircle aria-hidden="true" />

            Online

          </span>

        </div>

      </div>

      <button
        className="chatbot-close" type="button"
        onClick={onClose}
        aria-label="Close Techizen AI chat"
      >
        <FaTimes aria-hidden="true" />
      </button>

    </div>
  );
}